import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-clock-input',
  templateUrl: './clock-input.component.html',
  styleUrls: ['./clock-input.component.scss'],
})
export class ClockInputComponent implements OnInit {

  selectedTime: Date | null = null;

  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() { }

  onTimeChange(newTime: Date): void {
    this.selectedTime = newTime;
    this.change.emit(this.selectedTime);
  }

}
